/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'good-trends': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<rect pid="0" x="3" y="18" width="4" height="7" rx="1.5" ry="1.5"/><rect pid="1" x="10" y="13" width="4" height="12" rx="1.5" ry="1.5"/><rect pid="2" x="17" y="7" width="4" height="18" rx="1.5" ry="1.5"/><path pid="3" d="M21.998.49a.499.499 0 0 0-.024-.12.512.512 0 0 0-.017-.07.507.507 0 0 0-.049-.073.492.492 0 0 0-.063-.086L21.84.13a.485.485 0 0 0-.066-.04.473.473 0 0 0-.092-.055.478.478 0 0 0-.11-.022A.468.468 0 0 0 21.5 0h-4a.5.5 0 0 0 0 1h2.834C13.291 8.21 2.38 13.998 2.268 14.058a.5.5 0 1 0 .464.884C2.848 14.882 13.838 9.052 21 1.75V4.5a.5.5 0 0 0 1 0v-4z"/>'
  }
})
